import { COLORS } from "@/lib/api";
import { Check } from "lucide-react";

export const inputCls =
  "w-full bg-t-card border border-t-line rounded-xl px-4 py-2.5 text-sm text-t-ink placeholder:text-t-faint focus:outline-none focus:ring-2 focus:ring-t-primary/30 focus:border-t-primary transition-[border-color,box-shadow]";

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-t-primary hover:bg-t-primary-hover text-white font-medium px-5 py-2.5 rounded-xl transition-[background-color,transform] duration-200 shadow-sm active:scale-95 text-sm disabled:opacity-50";

export const btnSecondary =
  "inline-flex items-center justify-center gap-2 bg-t-surface hover:bg-t-surface-hover text-t-ink font-medium px-4 py-2 rounded-xl transition-[background-color,transform] duration-200 text-sm border border-t-line active:scale-95";

export const cardCls =
  "bg-t-card/90 backdrop-blur-sm border border-t-line rounded-2xl shadow-sm transition-[box-shadow,transform] duration-300 hover:shadow-md";

export const PageHeader = ({ eyebrow, title, subtitle, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 fade-up">
    <div>
      <p className="text-xs font-semibold tracking-[0.2em] uppercase text-t-primary mb-2">{eyebrow}</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-none text-t-ink">
        {title}
      </h1>
      {subtitle && <p className="text-sm md:text-base text-t-muted mt-3 max-w-xl">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const CheckCircle = ({ checked, onClick, testId, color = "rgb(var(--t-primary))" }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    aria-pressed={checked}
    className="h-6 w-6 shrink-0 rounded-full border-2 flex items-center justify-center transition-[background-color,transform] duration-200 active:scale-90 hover:scale-105"
    style={{ borderColor: color, backgroundColor: checked ? color : "transparent" }}
  >
    {checked && <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} />}
  </button>
);

export const ColorPicker = ({ value, onChange, palette = COLORS, testPrefix }) => (
  <div className="flex gap-2 flex-wrap">
    {Object.entries(palette).map(([key, hex]) => (
      <button
        key={key}
        type="button"
        data-testid={`${testPrefix}-color-${key}`}
        onClick={() => onChange(key)}
        title={key}
        className={`h-8 w-8 rounded-full border-2 transition-transform duration-200 hover:scale-110 ${
          value === key ? "border-t-ink scale-110" : "border-t-line"
        }`}
        style={{ backgroundColor: hex }}
      />
    ))}
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block space-y-1.5">
    <span className="text-xs font-semibold tracking-wide uppercase text-t-muted">{label}</span>
    {children}
  </label>
);

export const EmptyState = ({ title, text, testId }) => (
  <div data-testid={testId} className="text-center py-14 px-6 border border-dashed border-t-line rounded-2xl bg-t-surface/40">
    <p className="font-serif-display text-2xl text-t-ink">{title}</p>
    <p className="text-sm text-t-muted mt-1">{text}</p>
  </div>
);
